// extracted by mini-css-extract-plugin
export default {"modalOverlay":"zl-z","modalContent":"Al-z","header":"Bl-z","close":"Cl-z"};